import { Carousel, Card, Stack, Button, Image } from "react-bootstrap";
import { AssignImg } from "../../assets/images";



export default function ControlledCarousel(props) {
  
  return (
    <div className="select_area_owl">
      {
        props && props.list && props.list.length > 0 ?
          <Carousel className="carousel_area">
            {props.list.map((item, i) => (
              <Carousel.Item key={i}>
                <Stack
                  className="stack_area"
                >
                  <Card className="card_area">
                    <div className="select_img">
                      <div className="icon_img">
                        <Image 
                        src={AssignImg} 
                        alt="..." 
                        />
                      </div>
                      <div className="name_area">
                        <h5>{item.name}</h5>
                        <p>{item.specialization}</p>
                      </div>
                    </div>
                  </Card>
                  {/* <Card className="card_area">
                    <div className="select_img">
                      <div className="icon_img">
                        <Image src={AssignImg} alt="..." />
                      </div>
                      <div className="name_area">
                        <h5>Robert William</h5>
                        <p>Medical Staff</p>
                      </div>
                    </div>
                  </Card>
                  <Card className="card_area">
                    <div className="select_img">
                      <div className="icon_img">
                        <Image src={AssignImg} alt="..." />
                      </div>
                      <div className="name_area">
                        <h5>Robert William</h5>
                        <p>Medical Staff</p>
                      </div>
                    </div>
                  </Card>
                  <Card className="card_area">
                    <div className="select_img">
                      <div className="icon_img">
                        <Image src={AssignImg} alt="..." />
                      </div>
                      <div className="name_area">
                        <h5>Robert William</h5>
                        <p>Medical Staff</p>
                      </div>
                    </div>
                  </Card>
                  <Card className="card_area">
                    <div className="select_img">
                      <div className="icon_img">
                        <Image src={AssignImg} alt="..." />
                      </div>
                      <div className="name_area">
                        <h5>Robert William</h5>
                        <p>Medical Staff</p>
                      </div>
                    </div>
                  </Card> */}
                </Stack>
              </Carousel.Item>
            ))}
          </Carousel>
          :
          null
      }
    </div>
  );
}
